import type { ExamsCaptureTabsConfig } from '../../domain/entities/tabs.entity';

export interface TabsConfigDatasource {
  /** O JSON publicado (ou `{}`). Não rejeita. */
  getConfig(): Promise<ExamsCaptureTabsConfig>;
}

/**
 * As abas, **uma busca por carga de página**: guarda a promessa, e não o
 * valor, para o painel remontar sem pedir de novo a configuração que não muda
 * dentro da visita.
 */
export class TabsConfigRepositoryImpl {
  private readonly datasource: TabsConfigDatasource;
  private inFlight: Promise<ExamsCaptureTabsConfig> | null = null;

  constructor(datasource: TabsConfigDatasource) {
    this.datasource = datasource;
  }

  getConfig(): Promise<ExamsCaptureTabsConfig> {
    this.inFlight ??= this.datasource.getConfig();
    return this.inFlight;
  }
}
